import { AppShell, Center, Flex, Group } from '@mantine/core';

import Header from './Header';

interface ILayout {
  children: any;
  isMobile: boolean | undefined;
  t: any;
  title: string;
}

const Layout = ({ children, isMobile, t, title } : ILayout) => {
  return (
    <AppShell header={{ height: 75 }}>
      <AppShell.Header>
        <Flex bg={'#323343'} h={'100%'} ></Flex>
      </AppShell.Header>
      <AppShell.Main>
        <Center style={{ flexDirection: 'column' }}>
          <Header t={t} title={title} />
          <Group w={isMobile ? '70%' : '40%'} align='center'>
            {children}
          </Group>
        </Center>
      </AppShell.Main>
    </AppShell>
  )
}

export default Layout;